import React from 'react';
import { Shield } from 'lucide-react';
import '../Header/Header.css';
import './RotationMessage.css';

const RotationMessage = () => {
  return (
    <div className="rotation-message">
      <div className="rotation-header">
        <div className="logo-section">
          <div className="logo">
            <div className="logo-shield">
              <Shield size={50} />
              <span className="logo-text-k">K</span>
            </div>
            <span>RIME</span>
          </div>
        </div>
      </div>
      <div className="message">
        Rotate Device to Portrait Mode
      </div>
    </div>
  );
};

export default RotationMessage;